import { useState, useEffect } from "react";
import axios from "axios"

import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import SubHeader from "../../../../Components/ComponentsIndustry/SubHeader";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


import { useUser } from "../../../../providers/UserContext";

import {
  Container,
  SizeContainer,
  MainContainer,
  FirstContainer,
  InternalFirstContainer,
  SecondContainer,
  InternalSecondContainer,
  RotationInternalSecondContainer,
  ThirdContainer,
  UpThirdContainer,
  DownThirdContainer,
  ContainerInput
} from "./style";
import { useFries } from "../../../../providers/FriesContext";
import { useMachinery } from "../../../../providers/MachineryContext";

const ToolsProductionFries = () => {
  const [daytime, setDaytime] = useState(false);
  const [nightly, setNightly] = useState(false);
  const [quantProduzir, setQuantProduzir] = useState(0)
  const [custoTotal, setCustoTotal] = useState(0)
  const [custoMaoObra, setCustoMaoObra] = useState(0)
  const [custoPerdas, setCustoPerdas] = useState(0)
  // const [custoDepreciacao, setCustoDepreciacao] = useState(0)

  const history = new useHistory()

  const { user, rodada, industry } = useUser()
  const { getFriesStock } = useFries()
  const { maquinaFries } = useMachinery()

  const handleRotation = (rotation) => {
    switch (rotation) {
      case "daytime":
        setDaytime(!daytime);
        break;
      case "nightly":
        setNightly(!nightly);
        break;
      default:
        break;
    }
  };

  function handleProduction() {

    const data = {
      "codIndustria": industry?.industria,
      "produto": {
        "produto": 10
      },
      "rodada": rodada,
      "custoTotal": custoTotal,
      "diurno": daytime,
      "noturno": nightly,
      "producao": 0,
      "quantidadeProduzir": quantProduzir,
      "usuario": user
    }

    axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/producao/cadastrar", data)
      .then(response => {
        alert('Produção enviada com sucesso!')
        getFriesStock()
      })
      .catch(er => console.log(er))

    history.push("/toolsCommercialSausage")

  }

  useEffect(() => {

    if (user && rodada) {
      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/producao/obterCustoProducao/${industry?.industria}/${rodada?.rodada}/10`)
        .then(response => {

          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterPCP/${industry?.industria}/${rodada?.rodada}/10`)
            .then((response) => {
              console.log(response)
              //arrumar perdas
              setCustoPerdas((response.data.previsaoPerda / 100) * response.data.previsaoVenda)
              setQuantProduzir(response.data.previsaoProducao)
            })
        })
        .catch(er => console.log(er))

      if (daytime && nightly) {
        const calcCustoMaoObra = (20 * 200)
        setCustoMaoObra(calcCustoMaoObra)
      } else if (daytime || nightly) {
        const calcCustoMaoObra = (10 * 100)
        setCustoMaoObra(calcCustoMaoObra)
      } else {
        setCustoMaoObra(0)
      }

      setCustoTotal(custoMaoObra + custoPerdas + 3000 / 4)
    }
  }, [user, rodada, daytime, nightly, custoMaoObra, custoPerdas])

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/productions_1.svg"
          title="Produção"
          subTitle="(Inicio de produção de produtos)"
          style={["", "", "selection", "", ""]}
        />
        <SubHeader
          style={["", "", "", "selection", ""]}
          path1="toolsProductionSausage"
          path2="toolsProductionChicken"
          path3="toolsProductionChickenCut"
          path4="toolsProductionFries"
        />
        {industry?.batata ?

          <>
            <MainContainer>
              <h2>
                Produção de <span>Batata</span>
              </h2>
              <FirstContainer>
                <InternalFirstContainer>
                  <h3>
                    <img src="./images/icon_tools.svg" alt="icon_tools" /> N° de
                    Maquinário
                  </h3>
                  <p className="background">{industry?.batata}</p>
                </InternalFirstContainer>
                <InternalFirstContainer>
                  <h3>
                    <img src="./images/icon_management.svg" alt="icon_management" />
                    N° de Operadores
                  </h3>
                  <p>{(nightly && daytime ? 20 * industry?.batata : 10 * industry?.batata)}</p>
                </InternalFirstContainer>
              </FirstContainer>

              {custoPerdas ?
                <>
                  <SecondContainer>
                    <h3>Turnos</h3>
                    <InternalSecondContainer>
                      <RotationInternalSecondContainer
                        onClick={() => handleRotation("daytime")}
                      >
                        <h4>Diurno</h4>
                        <img src="./images/daytime.svg" alt="daytime" />
                        {daytime ? <button className="checked" /> : <button />}
                      </RotationInternalSecondContainer>
                      <RotationInternalSecondContainer
                        onClick={() => handleRotation("nightly")}
                      >
                        <h4>Noturno</h4>
                        <img src="./images/nightly.svg" alt="nightly" />
                        {nightly ? <button className="checked" /> : <button />}
                      </RotationInternalSecondContainer>
                    </InternalSecondContainer>
                  </SecondContainer>

                  <ThirdContainer>
                    <h3>
                      <img src="./images/product_recipe.svg" alt="product_recipe" /> CPF
                      <small>(Custo de produto fabricado)</small>
                    </h3>
                    <UpThirdContainer>
                      {/* <div>
                <img src="./images/material_cost.svg" alt="material_cost" />
                <p>Custo da Matéria-prima</p> <input placeholder="R$0,00" />
                <img
                  src="./images/cifrao.svg"
                  alt="cifrão"
                  className="cifrao"
                />
              </div> */}
                      <div>
                        <img
                          src="./images/commercial_manager.svg"
                          alt="commercial_manager"
                        />
                        <p>Custo de mão de obra</p> <input placeholder={"R$" + custoMaoObra?.toFixed(2)} />
                        <img
                          src="./images/cifrao.svg"
                          alt="cifrão"
                          className="cifrao"
                        />
                      </div>
                      <div>
                        <img
                          src="./images/depreciation_machinery.svg"
                          alt="depreciation_machinery"
                        />
                        <p>Depreciação de maquinario</p> <input placeholder="R$210" />
                        <img
                          src="./images/cifrao.svg"
                          alt="cifrão"
                          className="cifrao"
                        />
                      </div>
                      <div>
                        <img src="./images/losses.svg" alt="losses" />
                        <p>Perdas</p> <input placeholder={"R$" + custoPerdas?.toFixed(2)} />
                        <img
                          src="./images/cifrao.svg"
                          alt="cifrão"
                          className="cifrao"
                        />
                      </div>
                    </UpThirdContainer>
                    <DownThirdContainer>
                      <div>
                        <p>Total</p>
                        <p className="value">
                          R${custoTotal?.toFixed(2)} <img src="./images/cifrao.svg" alt="cifrao" />
                        </p>
                      </div>

                      <div>
                        <p>Qnt. a produzir</p>
                        <p className="value">
                          {quantProduzir?.toFixed(2)} <img src="./images/productions.svg" alt="productions" />
                        </p>
                      </div>

                      {/* <div>
                <p>Tempo de produção</p>
                <p className="value">
                  0 <img src="./images/icon_tools.svg" alt="icon_tools" />
                </p>
              </div> */}
                    </DownThirdContainer>
                  </ThirdContainer>
                </> :
                <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
                  <div>CADASTRE O PCP PARA PRODUZIR ESTE PRODUTO</div>
                </ContainerInput>}
            </MainContainer>

            <FooterButton onHandle={() => {
              handleProduction()
            }} text="Confirmar" />
          </> :
          <ContainerInput style={{ color: "white", padding: 20, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>ADQUIRA O MAQUINÁRIO PARA PRODUZIR ESTE PRODUTO</div>
          </ContainerInput>
        }
      </SizeContainer>
    </Container>
  );
};
export default ToolsProductionFries;
